import { createContext } from "react";

export interface NotificationContextValue {
  resolveNotification: (id: string) => Promise<void>;
  invalidateNotifications: () => void;
}

export const NotificationContext = createContext<NotificationContextValue | null>(null);